import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface PlaylistRefreshEvent {
  playlistId?: string;
  playlistName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class PlaylistRefreshService {
  private refreshSubject = new Subject<PlaylistRefreshEvent>();
  public refresh$ = this.refreshSubject.asObservable();

  triggerRefresh(event: PlaylistRefreshEvent): void {
    this.refreshSubject.next(event);
  }
}